import { Injectable } from "@angular/core"
import { DateFormatUtils } from "@app/cadastro/admin/utils/date-format-utils"
import { UtilsService } from "@app/shared/utils/utils.service"
import {
  NgbDateStruct,
  NgbDateParserFormatter,
} from "@ng-bootstrap/ng-bootstrap"

@Injectable()
export class MyFormatter extends NgbDateParserFormatter {

  constructor(private utils: UtilsService, public formatDate: DateFormatUtils) {
    formatDate.getCurrentLanguage()
    super()
  }

  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split("-")
      if (dateParts.length === 1 && this.utils.isNumber(dateParts[0])) {
        return { year: this.utils.toInteger(dateParts[0]), month: null, day: null }
      } else if (
        dateParts.length === 2 &&
        this.utils.isNumber(dateParts[0]) &&
        this.utils.isNumber(dateParts[1])
      ) {
        return {
          year: this.utils.toInteger(dateParts[0]),
          month: this.utils.toInteger(dateParts[1]),
          day: null,
        }
      } else if (
        dateParts.length === 3 &&
        this.utils.isNumber(dateParts[0]) &&
        this.utils.isNumber(dateParts[1]) &&
        this.utils.isNumber(dateParts[2])
      ) {
        return {
          year: this.utils.toInteger(dateParts[0]),
          month: this.utils.toInteger(dateParts[1]),
          day: this.utils.toInteger(dateParts[2]),
        }
      }
    }
    return null
  }

  format(date: NgbDateStruct): string {
    if (this.formatDate.isBraziliamFormat()) {
      return date
        ? `${this.utils.isNumber(date.day) ? this.utils.padNumber(date.day) : ""}/${this.utils.isNumber(date.month) ? this.utils.padNumber(date.month) : ""
        }/${date.year}`
        : ""
    } else {
      return date
        ? `${this.utils.isNumber(date.month) ? this.utils.padNumber(date.month) : ""}/${this.utils.isNumber(date.day) ? this.utils.padNumber(date.day) : ""
        }/${date.year}`
        : ""
    }
  }
}
